module.exports = __webpack_public_path__ + "static/subset-UniNeueThin-Italic-73491b42bceb3203ee6da573ade8d56b.woff";